import { render, staticRenderFns } from "./RecordsConsumption.vue?vue&type=template&id=4e676fe2&scoped=true"
import script from "./RecordsConsumption.vue?vue&type=script&lang=js"
export * from "./RecordsConsumption.vue?vue&type=script&lang=js"
import style0 from "./RecordsConsumption.vue?vue&type=style&index=0&id=4e676fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e676fe2",
  null
  
)

export default component.exports